module.exports = __webpack_public_path__ + "f2ea62f5.png";